import ExpressPlanFooter from './ExpressPlanFooter';

export default ExpressPlanFooter;
